export default function getRandomItem<T = unknown>(items: T[]): T {
  return items[Math.floor(Math.random() * items.length)];
}
